/**
 * Oturum durumu.
 *
 * Erişim jetonu **yalnızca bellekte** tutulur, `localStorage`'a yazılmaz: XSS
 * ile çalınabilecek bir yere kalıcı bir kimlik bilgisi koymak, kısa ömürlü
 * jeton kullanmanın anlamını ortadan kaldırır. Sayfa yenilendiğinde oturum
 * httpOnly çerezdeki yenileme jetonundan geri kurulur (YES-83).
 */
type Listener = () => void

let accessToken: string | null = null
let bootstrapped = false
const listeners = new Set<Listener>()

function notify() {
  listeners.forEach((listener) => listener())
}

export function getAccessToken(): string | null {
  return accessToken
}

export function setAccessToken(token: string | null): void {
  accessToken = token
  notify()
}

export function isBootstrapped(): boolean {
  return bootstrapped
}

export function markBootstrapped(): void {
  bootstrapped = true
  notify()
}

export function subscribeAuth(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
